<template>
    <div class="Loadingscreen">
        <div class="ls-container">

            <img class="ls-background" :src="backgroundImage" alt="">

            <div class="ls-overlay">
                <!-- Default Loadingscreen -> GIF -->
                <video v-if="logoURL == '/Flux360Logo.svg'" class="ls-video" :src="publicPath+'/media/loadingscreen.webm'" loop autoplay muted></video>

                <!-- Branded Loadingscreen -> Logo + Generic GIF-->
                <div v-else>
                    <img class="ls-logo" :src="publicPath+'/media'+mediaURL+logoURL" alt="">
                    <svg class="ls-animation" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 80 80" xml:space="preserve">
                        <path id="spinner" d="M40,72C22.4,72,8,57.6,8,40C8,22.4,22.4,8,40,8c17.6,0,32,14.4,32,32c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-15.4-12.6-28-28-28S12,24.6,12,40s12.6,28,28,28c1.1,0,2,0.9,2,2S41.1,72,40,72z">
                            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 40 40" to="360 40 40" dur="1s" repeatCount="indefinite"/>
                        </path>
                    </svg>
                </div>

                <!-- Progress Visualization -> %-Text-->
                <!-- p class="ls-text" v-show="enablePreloadAllSituations">0%</p -->     
            </div>

            

        </div>          
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    data: () => ({
        publicPath: process.env.BASE_URL,
    }),
    computed: {
        ...mapGetters(['logoURL','currentSituation','mediaURL','thumbnailType','panoramaTour','enablePreloadAllSituations']),
        backgroundImage(){
            if(this.panoramaTour)
                return this.publicPath+'/media'+this.mediaURL+'/'+this.currentSituation.name.trim()+'.'+this.thumbnailType;
        }
    },
    mounted: function(){
        document.getElementsByClassName("ls-container")[0].style.opacity = 1; 
    }
}
</script>

<style>
    .Loadingscreen{
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 100;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgb(46, 46, 46);
    }
    .ls-container{
        opacity: 0;
        transition: 1s opacity ease-in;
    }
    .ls-background{
        width: 102vw !important;
        height: 102vh !important;
        object-fit: cover;
        filter: blur(5px);
        opacity: 0.3;
    }
    .ls-overlay{
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        width: 100%;
        height: 100%;
        flex-direction: column;
    }
    .ls-video{        
        width: 100px;
    }
    .ls-logo{
        width: 350px;
        height: 350px;
    }
    .ls-animation{
        fill: var(--primaryColor);
        width: 150px;
        height: 150px;
        margin: auto;
        margin-top: 50px;
        display: block;
    }
    .ls-text{
        font-size: 25px;
        text-align: center;
        margin: 20px;
        color: white;
        filter: drop-shadow(0px 0px 2px rgba(0,0,0,0.4)) drop-shadow(0px 0px 10px rgba(0,0,0,0.2));
    }
</style>